import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import useSWR from 'swr'

import { fetchUpsellMargin } from 'facades/fetchUpsellMargin'
import { money } from 'utils/money'

const UpsellContent: FC<{ applicationId: string }> = ({ applicationId }) => {
  const { t } = useTranslation(['assignments'])
  const { data } = useSWR(['upsell-margin', applicationId], () =>
    fetchUpsellMargin(applicationId),
  )

  if (data?.delta) {
    return (
      <p>
        <b>{t('card.loan-info.upsell.value')}:</b>{' '}
        <strong>{money(data.delta)}</strong>
      </p>
    )
  }

  return (
    <p>
      {t('card.loan-info.upsell.no-margin')}
      <strong />
    </p>
  )
}

export { UpsellContent }
